import { SxProps } from "@mui/material";

export const serviceReviewsPageStyles: Record<string, SxProps> = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
  },
  contentContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: "16px",
    justifyContent: "space-between",
  },
  reviewsSection: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: { xs: "100%", lg: "553px" },
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    padding: "16px",
  },
  title: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "130%",
  },
  emptyStateContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  emptyStateImage: {
    width: "1467x",
    height: "140px",
  },
  emptyStateText: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
  },
  peopleReviewsTitle: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "130%",
  },
};
